import React from "react";
import {
  Checkbox,
  Dropdown,
  Container,
  Grid,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import _EmailExemptionModal from "./components/EmailExemptionModal";
import _DeleteEmailExemptionModal from "./components/DeleteEmailExemptionModal";
import EmailExemptionService from "../../services/EmailExemptions";
import { createDateTimeFormatter } from "../../components/helpers";
import CustomDropdown from "../../components/CustomDropdown";
import BaseTable from "../../components/BaseTable";
import AuthService from "../../services/Auth";
import ACL_RELATIONSHIPS from "../../acl-relationships";
import withRoleCheck from "../../components/hocs/withRoleCheck";

import "../../styles/table.scss";
import setPageTitle from "../../helpers/title";

const EmailExemptionModal = withRoleCheck(_EmailExemptionModal, [
  ACL_RELATIONSHIPS.emailExemption.read,
  ACL_RELATIONSHIPS.emailExemption.create,
]);

const EditEmailExemptionModal = withRoleCheck(_EmailExemptionModal, [
  ACL_RELATIONSHIPS.emailExemption.create,
  ACL_RELATIONSHIPS.emailExemption.edit,
  ACL_RELATIONSHIPS.emailExemption.read,
]);

const DeleteEmailExemptionModal = withRoleCheck(_DeleteEmailExemptionModal, [
  ACL_RELATIONSHIPS.emailExemption.read,
  ACL_RELATIONSHIPS.emailExemption.delete,
]);

class EmailExemptionsTable extends BaseTable {
  constructor(props) {
    super(props);

    this.queryMethod = EmailExemptionService.getEmailExemptions;

    this.state = {
      ...this.state,
      header: "Email Exemptions",
      headerIcon: "mail outline",
      className: "EmailExemption",
      tableName: "email_exemptions",
      noDataText: "No Email Exemptions found. Create one.",
      createButton: (
        <EmailExemptionModal button fetchExemptions={this.fetchData} />
      ),
    };
  }

  async componentDidMount() {
    setPageTitle("Email Exemptions");
    if (AuthService.isLoggedIn()) {
      await this.fetchData();
      this.setState({
        createButton: (
          <EmailExemptionModal
            button
            onSuccess={this.fetchData}
            fetchExemptions={this.fetchData}
            isNew={true}
          />
        ),
      });
    }
  }

  deleteEmailExemption = async exemption_id => {
    await EmailExemptionService.deleteEmailExemption(exemption_id);
    this.fetchData();
  };

  formatDate = () => createDateTimeFormatter({ format: "YYYY-MM-DD HH:mm" });

  setColumns = () => {
    const columns = [
      {
        Header: () => (
          <Checkbox
            onChange={this.onSelectAll}
            checked={this.state.allSelected}
          />
        ),
        resizable: false,
        sortable: false,
        headerClassName: "centered non-sortable",
        width: 40,
        className: "centered",
        Cell: ({ original: { id, name } }) => (
          <Checkbox
            onChange={this.handleChange}
            name={name}
            id={id}
            checked={this.state.checked[id]}
          />
        ),
      },
      {
        Header: "ID",
        accessor: "id",
        width: 40,
      },
      {
        Header: "Email Address",
        accessor: "email_address.email",
      },
      {
        Header: "Campaign",
        accessor: "campaign.name",
        Cell: props => (
          <Link
            to={{
              pathname: "/campaigns/" + props.original.campaign.id,
              state: {
                campaignId: props.original.campaign.id,
              },
            }}
          >
            {props.value}
          </Link>
        ),
      },
      {
        Header: "Created By",
        accessor: "creator_user.full_name",
      },
      {
        Header: "Justification",
        accessor: "justification",
      },
      {
        Header: "Source",
        accessor: "source",
      },
      {
        Header: "Notes",
        accessor: "notes",
      },
      {
        Header: "Actions",
        id: "actions",
        headerClassName: "action-menu non-sortable",
        className: "action-menu",
        sortable: false,
        Cell: ({ original: { id } }) => (
          <CustomDropdown icon="ellipsis horizontal">
            <Dropdown.Menu direction="left">
              <EditEmailExemptionModal
                fetchExemptions={this.fetchData}
                isClone={false}
                emailExemptionId={id}
              />
              <DeleteEmailExemptionModal
                menuTrigger
                onDelete={this.fetchData}
                exemptionId={id}
              />
              <EmailExemptionModal
                fetchExemptions={this.fetchData}
                isClone={true}
                emailExemptionId={id}
              />
            </Dropdown.Menu>
          </CustomDropdown>
        ),
      },
    ];
    this.initTableSettings(columns);
  };

  render() {
    return (
      <Container fluid className="route sub-route">
        <div className="campaign-segment">
          <Segment>{this.renderTable()}</Segment>
        </div>
      </Container>
    );
  }
}

export default EmailExemptionsTable;
